<template>
  <div class="container">
    <div class="flex">
      <div v-if="isSmartPhone" class="btn" @click="prev"><img src="@/assets/img/arrow_prev.svg" alt></div>
      <CounterComponent class="denominator" :count="total"/>
      <div class="numerator">
        <p>10</p>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from "lodash";
import isMobile from "ismobilejs";
import CounterComponent from "@/components/Counter.vue";

export default {
  name: "ResultCounterComponent",
  components: {
    CounterComponent
  },
  data() {
    return {
      isSmartPhone: isMobile.phone
    };
  },
  computed: {
    total() {
      return this.$store.state.top_ranker;
      // return _.sum(_.values(this.$store.state.shoes));
      // return _.sumBy(_.values(this.$store.state.shoes), function(o) {
      //   return Number(o);
      // });
    },
  },
  methods: {
    prev (e) {
      this.$emit('prev')
    }
  }
};
</script>

<style scoped lang="scss">
$space: 0.78em;
.container {
  position: relative;
  background-color: $text-color;
  color: $bg-color;
  padding: vw(15);
}
.flex {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
}
.numerator {
  display: flex;
  justify-content: flex-end;
  background-image: url("../assets/img/slash.svg");
  background-repeat: no-repeat;
  background-position: left center;
  background-size: vw(81) vw(86);
  width: vw(100);
  height: vw(86);
  > p {
    font-size: vw(48);
    height: $space;
    margin-top: auto;
  }
}
.denominator {
  font-size: vw(110);
  height: $space;
}
.btn {
  cursor: pointer;
  position: absolute;
  left: 0;
}
@media #{$mq-md} {
  .container {
    padding: vw(35, 1600);
  }
  .numerator {
    background-size: vw(138, 1600) vw(142, 1600);
    width: vw(180, 1600);
    height: vw(142, 1600);
    > p {
      font-size: vw(84, 1600);
    }
  }
  .denominator {
    font-size: vw(178, 1600);
  }
}
</style>
